import React from 'react'
import { Title } from '@mantine/core'
import { Card } from '../Card'
import useStyles from './GeneralCard.styles'

interface IProps {
  children: React.ReactNode
  title?: React.ReactNode
  className?: string
  titleProps?: any
  cardProps?: any
}

export const GeneralCard: React.FC<IProps> = ({
  children,
  title,
  className,
  titleProps,
  cardProps,
  ...props
}) => {
  const { classes, cx } = useStyles()

  const renderTitle = () => {
    if (typeof title === 'string') {
      return (
        <Title mb={'md'} order={4} {...titleProps}>
          {title}
        </Title>
      )
    }

    return title
  }

  return (
    <Card
      className={cx(classes.card, {
        [`${className}`]: className,
      })}
      shadow={'xs'}
      py={32}
      px={60}
      {...cardProps}
    >
      {title && renderTitle()}

      {children}
    </Card>
  )
}
